/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateOtherQaEquipmentDtoBrand1 } from './CreateOtherQaEquipmentDtoBrand1';
import {
    CreateOtherQaEquipmentDtoBrand1FromJSON,
    CreateOtherQaEquipmentDtoBrand1FromJSONTyped,
    CreateOtherQaEquipmentDtoBrand1ToJSON,
} from './CreateOtherQaEquipmentDtoBrand1';
import type { CreateOtherQaEquipmentDtoDeviceInterfaceType } from './CreateOtherQaEquipmentDtoDeviceInterfaceType';
import {
    CreateOtherQaEquipmentDtoDeviceInterfaceTypeFromJSON,
    CreateOtherQaEquipmentDtoDeviceInterfaceTypeFromJSONTyped,
    CreateOtherQaEquipmentDtoDeviceInterfaceTypeToJSON,
} from './CreateOtherQaEquipmentDtoDeviceInterfaceType';
import type { CreateOtherQaEquipmentDtoSingleDetectorConnectorType } from './CreateOtherQaEquipmentDtoSingleDetectorConnectorType';
import {
    CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeFromJSON,
    CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeFromJSONTyped,
    CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeToJSON,
} from './CreateOtherQaEquipmentDtoSingleDetectorConnectorType';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { QaEquipmentSubCategory } from './QaEquipmentSubCategory';
import {
    QaEquipmentSubCategoryFromJSON,
    QaEquipmentSubCategoryFromJSONTyped,
    QaEquipmentSubCategoryToJSON,
} from './QaEquipmentSubCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';

/**
 * 
 * @export
 * @interface CreatePtwQaEquipmentWithoutSerialNumberDto
 */
export interface CreatePtwQaEquipmentWithoutSerialNumberDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {QaEquipmentSubCategory}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    subCategory: QaEquipmentSubCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    typeNumber?: string | null;
    /**
     * 
     * @type {CreateOtherQaEquipmentDtoBrand1}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    brand1?: CreateOtherQaEquipmentDtoBrand1 | null;
    /**
     * 
     * @type {CreateOtherQaEquipmentDtoDeviceInterfaceType}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    deviceInterfaceType?: CreateOtherQaEquipmentDtoDeviceInterfaceType | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    defaultImageId?: string | null;
    /**
     * 
     * @type {CreateOtherQaEquipmentDtoSingleDetectorConnectorType}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    singleDetectorConnectorType?: CreateOtherQaEquipmentDtoSingleDetectorConnectorType | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    isRegistrable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithoutSerialNumberDto
     */
    $type?: CreatePtwQaEquipmentWithoutSerialNumberDtoTypeEnum;
}


/**
 * @export
 */
export const CreatePtwQaEquipmentWithoutSerialNumberDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoCreatePtwQaEquipmentWithoutSerialNumberDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreatePtwQaEquipmentWithoutSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreatePtwQaEquipmentWithoutSerialNumberDtoTypeEnum = typeof CreatePtwQaEquipmentWithoutSerialNumberDtoTypeEnum[keyof typeof CreatePtwQaEquipmentWithoutSerialNumberDtoTypeEnum];


/**
 * Check if a given object implements the CreatePtwQaEquipmentWithoutSerialNumberDto interface.
 */
export function instanceOfCreatePtwQaEquipmentWithoutSerialNumberDto(value?: unknown): value is CreatePtwQaEquipmentWithoutSerialNumberDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreatePtwQaEquipmentWithoutSerialNumberDtoTypeEnum)[0];
}

export function CreatePtwQaEquipmentWithoutSerialNumberDtoFromJSON(json: any): CreatePtwQaEquipmentWithoutSerialNumberDto {
    return CreatePtwQaEquipmentWithoutSerialNumberDtoFromJSONTyped(json, false);
}

export function CreatePtwQaEquipmentWithoutSerialNumberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePtwQaEquipmentWithoutSerialNumberDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'subCategory': QaEquipmentSubCategoryFromJSON(json['subCategory']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'typeNumber': !exists(json, 'typeNumber') ? undefined : json['typeNumber'],
        'brand1': !exists(json, 'brand1') ? undefined : CreateOtherQaEquipmentDtoBrand1FromJSON(json['brand1']),
        'deviceInterfaceType': !exists(json, 'deviceInterfaceType') ? undefined : CreateOtherQaEquipmentDtoDeviceInterfaceTypeFromJSON(json['deviceInterfaceType']),
        'defaultImageId': !exists(json, 'defaultImageId') ? undefined : json['defaultImageId'],
        'singleDetectorConnectorType': !exists(json, 'singleDetectorConnectorType') ? undefined : CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeFromJSON(json['singleDetectorConnectorType']),
        'isRegistrable': !exists(json, 'isRegistrable') ? undefined : json['isRegistrable'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreatePtwQaEquipmentWithoutSerialNumberDtoToJSON(value?: CreatePtwQaEquipmentWithoutSerialNumberDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'description': value.description,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isAvailable': value.isAvailable,
        'imageId': value.imageId,
        'subCategory': QaEquipmentSubCategoryToJSON(value.subCategory),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'typeNumber': value.typeNumber,
        'brand1': CreateOtherQaEquipmentDtoBrand1ToJSON(value.brand1),
        'deviceInterfaceType': CreateOtherQaEquipmentDtoDeviceInterfaceTypeToJSON(value.deviceInterfaceType),
        'defaultImageId': value.defaultImageId,
        'singleDetectorConnectorType': CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeToJSON(value.singleDetectorConnectorType),
        'isRegistrable': value.isRegistrable,
        '$type': value.$type,
    });
}

